import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addModal, removeModal } from '../../../app-root/reducers/modals-reducer';

const mainInstance = () => {
  // used only inside app.js
  const renderedModals = useSelector(({ modals }) => modals.renderedModals);
  const renderedModalsRef = useRef(renderedModals);
  useEffect(() => {
    renderedModalsRef.current = renderedModals;
  }, [renderedModals]);

  useEffect(() => {
    const ESCHandler = (e) => {
      const modals = renderedModalsRef.current;
      if (e.keyCode === 27) {
        if (modals.length > 0) {
          modals[modals.length - 1].callback();
          //  NOTE: remember that this is an async event listener,
          //  so if there's any state variables in the callback fn,
          // they will prolly be at their initial state
        }
      }
    };
    document.addEventListener('keydown', ESCHandler);
    return () => {
      document.removeEventListener('keydown', ESCHandler);
    };
  }, []);
};

const modalInstance = () => {
  const dispatch = useDispatch();
  const registerModal = (callback) => {
    const id = Math.random();
    dispatch(addModal({ callback, id }));
    return id;
  };

  const unregisterModal = (id) => {
    dispatch(removeModal({ id }));
  };

  return [registerModal, unregisterModal];
};

const useModalManager = (main) => {
  if (main) {
    return mainInstance();
  }
  return modalInstance();
};

export default useModalManager;
